/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import 'isomorphic-fetch';
import { loadLanguage, getSessionDatas, decrypt } from '../utils';
import { settings } from '../config/constants';
import { handleError, clearError, changeLanguage } from '../views/App/state/action';

import errorMapping from '../config/errorMapping';
import history from '../utils/history';
import paths from '../config/path';

// encryptList接口list返回的response是加密的，需要解密处理
const encryptList = [
    'v1/busandqs/',
    'v1/qianhai'
]
/**
 * dummy env: isDummy === true 
 */
// const isDummy = false;
export const ErrorType = {
    input: 'input',
    system: 'system',
    redirect: 'redirect'
}

const getReqParamsDatas = (setting) => {
    let finalParams = {};
    const { paramsObj, isUpload } = setting;
    if (typeof (isUpload) !== "undefined" && isUpload) {
        const data = new FormData();
        for (let key in paramsObj) {
            const subObj = paramsObj[key];
            if (key === 'file') {
                data.append(key, subObj, subObj.name);
            } else {
                data.append(key, subObj);
            }
        }
        finalParams = data
    } else if (paramsObj) {
        finalParams = JSON.stringify(paramsObj)
    }
    return finalParams;
}

const getHeader = (setting) => {
    const userSelectedLanguage = loadLanguage();
    let headerObj = {
        "Content-Type": "application/json;charset=UTF-8",
        "user-language": `${userSelectedLanguage};CN`, // format : language;locale 
        ...setting.headers
    };
    if (typeof (setting.isUpload) !== "undefined" && setting.isUpload) {
        delete headerObj["Content-Type"];
        headerObj.client_id = setting.client_id;
        headerObj.client_secret = setting.client_secret;
    }
    const headerInfo = getSessionDatas().headerInfo;
    headerObj = (!setting.noNeedToken && Object.assign({}, headerObj, headerInfo)) || headerObj;
    return headerObj;
}
export const apiFetch = (url, settingFetch) => dispatch => {
    // dispatch && dispatch(clearError());
    const setting = Object.assign({}, settings, settingFetch);
    const isI18n = typeof (url) === "string" && url.match("local") !== null;
    url = isI18n ? url : url["api"];
    const apiUrl = (setting.hostname || setting.default.hostname) + url;
    const method = setting.method || setting.default.method;
    let reqBody = {};
    if (method === "GET") {
        reqBody = {
            method: method,
            headers: getHeader(setting),
            credentials: "include"
        };
    } else {
        reqBody = {
            method: method,
            headers: getHeader(setting),
            body: getReqParamsDatas(setting),
            credentials: "include"
        };
    }
    if (dispatch){
        dispatch(clearError());
        dispatch(changeLanguage(loadLanguage()))
    }
    return new Promise((resolve, reject) => {
        fetch(apiUrl, reqBody)
            .then(response => {
                if (200 <= response.status && response.status < 300) {
                    return response.json()
                } else {
                    throw new HSBCError(response.status, response.statusText)
                }
            })
            .then(resData => {
                let errorCode = 0;
                let errorMessage = 'Unknown Error'
                if (typeof resData.respCode !== 'undefined') {
                    errorCode = resData.respCode;
                    errorMessage = resData.message;
                } else {
                    errorCode = resData.status;
                    errorMessage = resData.message;
                }
                if (isI18n || errorCode === '200' || errorCode === 'RECEIVED'  || resData.documents) {
                    // 判断接口返回的是加密数据，需解密处理
                    let list = encryptList.filter((item) => apiUrl.indexOf(item) > 0)
                    if (list.length > 0) {
                        const { applicationId } = getSessionDatas();
                        resData.respBody = decrypt(resData.respBody, applicationId) || resData.respBody
                    }
                    resolve(resData);
                } else {
                    const error = new HSBCError(errorCode, errorMessage);
                    if (error.errorType === ErrorType.system) {
                        dispatch && dispatch(handleError(error));
                        reject(error);
                    } else if (error.errorType === ErrorType.redirect) {
                        history.push(paths.systemErrorMessage.path);
                        reject();
                    }  else {
                        reject(error);
                    }
                    
                }
            })
            .catch(error => {
                if (error.errorType === ErrorType.system) {
                    dispatch && dispatch(handleError(error));
                } else if (error.errorType === ErrorType.redirect) {
                    history.push(paths.systemErrorMessage.path)
                }
                reject();
            })
    })
    
};

export const multiFetchApi = (urls, settingFetch) => dispatch => {
    let setting = [];
    if (Array.isArray(settingFetch) && settingFetch.length > 0) {
        setting = settingFetch.map(item => Object.assign({}, settings, item));
    };
    const apiCalls = urls.map((url, index) => {
        return apiFetch(url, setting[index] || {})(dispatch);
    });
    return Promise.all(apiCalls);
};

export class HSBCError {
    constructor(errorCode, errorMessage) {
        this.errorCode = errorCode.toString().replaceAll('-', '');
        this.errorMessage = errorMessage;
        this.errorType = errorMapping[this.errorCode] || ErrorType.system;
        this.errorCode = errorMapping[this.errorCode] ? this.errorCode : "RBB00001";
    }
}


// WEBPACK FOOTER //
// ./src/apiClient/index.js